import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup,
    Badge,
    Chip
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { globalstyles } from '../lib/definitions';
import { Backspace, CheckBoxOutlineBlank, Close, LibraryAddCheck, List, Padding, PictureAsPdf, PlayArrow, Save, Stop } from '@mui/icons-material';
import { useEvent } from '../context/eventContext';
import { ContainerPdfDialog } from './PdfContainerDialog';
import { get_Cow_byID } from '../FirebaseUtils/dbCow';
import { QrCodeDialog } from './QrCodeDialog';





const document_list = [
    { id: 'catalog', label: 'catalogo' },
]


export const EventDocumentsDialog = forwardRef(({ editFn }, ref) => {
    const pdfRef = useRef()
    const [open, setOpen] = useState(false);
    const [cur_event, setCurEvent] = useState({})
    const { selEvent } = useEvent()

    useImperativeHandle(ref, () => {
        return {
            onOpen(el, i, m_list) {
                setOpen(true);
                setCurEvent(el)
            },
        }
    })


    const handleClose = () => {
        setOpen(false);
    };

    const getRealCow = async (c) => {
        console.log(c)
        const res = await get_Cow_byID(selEvent.id, c.id)
        console.log("COW GET ID", res)
        return res
    }

    const handlePdf = async (l, p) => {
        let doc_data = { section_title: 'titolo', cow_list: [] }
        if (p === 'prering') {
            doc_data = {
                section_title: `${cur_event.event_name} ${cur_event.event_description && cur_event.event_description.length > 0 && '- ' + cur_event.event_description}`,
                cow_list: await Promise.all(cur_event.cow_list.map(async c => await getRealCow(c)))
            }
        } else if (p === 'prering_light') {
            doc_data = {
                section_title: `${cur_event.event_name} ${cur_event.event_description && cur_event.event_description.length > 0 && '- ' + cur_event.event_description}`,
                cow_list: cur_event.cow_list
            }
        } else {
            doc_data = {
                section_title: `${cur_event.event_name} ${cur_event.event_description && cur_event.event_description.length > 0 && '- ' + cur_event.event_description}`,
                cow_list: cur_event.cow_list
            }
        }
        console.log(doc_data)
        pdfRef.current.onOpen(doc_data, l, p)
    }


    return (


        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth={true} disableEscapeKeyDown>
            <ContainerPdfDialog ref={pdfRef} />
            <DialogTitle>

                <Grid container flexDirection={"column"}>
                    <Grid container alignItems={"center"} justifyContent={"space-around"}>
                        <Grid size="auto">
                            Documenti evento
                        </Grid>
                        <Grid size="auto">
                            <Box sx={{ fontSize: '0.7em' }}>{cur_event?.event_description}</Box>
                        </Grid>
                        <Grid size="auto">
                        </Grid>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Box sx={globalstyles.sectionHeader}>
                    Documenti preparatori
                </Box>
                <Grid container sx={globalstyles.list_row}>
                    <Grid size={"grow"}>
                        qr code pagina web pubblica
                    </Grid>
                    <Grid size={2}>
                        <QrCodeDialog value={cur_event.id} />
                    </Grid>
                </Grid>

                {document_list.map((d, k) => (
                    <Grid container key={k} sx={globalstyles.list_row}>
                        <Grid size={"grow"}>
                            {d.label}
                        </Grid>
                        <Grid size={2}>
                            <Button disabled onClick={() => handlePdf(d.label, d.id)} variant="outlined" size="small" startIcon={<PictureAsPdf />}></Button>
                        </Grid>
                    </Grid>
                ))}
            </DialogContent>
            <DialogActions>
                <ButtonGroup>
                    <Button variant='outlined' key={'bc'} onClick={handleClose} startIcon={<Close />}>Chiudi</Button>
                </ButtonGroup>
            </DialogActions>
        </Dialog>

    )

})

